/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Driver_TitleInputs */

const vi_dashboard_driver_title = /** @type {(inputs: Dashboard_Driver_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảng điều khiển giao hàng`)
};

/**

* @param {Dashboard_Driver_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_driver_title = /** @type {((inputs?: Dashboard_Driver_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Driver_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_driver_title(inputs)
});